export class MercadoriasClassificacaoModel {
  id: number;
  nome: string;
  id_mercadoria: number = null;
  id_defeito: number = null;
  percentual: number = 0;
  percentual_tipo: string = '';
  cor: number = 1;
}




// WEBPACK FOOTER //
// ./src/app/mercadorias-classificacao/mercadorias-classificacao.model.ts